<div class="tibo-mydash-wrapper tibo-right-container old-dashboard-parent-container">

	<button id="resizeBtn" pButton class="tibo-mydash-resize-btn" type="button">Resize All</button>



	<div class="tibo-mydash-dashlistbtn-dashoptsbtn-container" *ngIf="showDashboardList1">
		<div class="dashboard-top-header p-d-flex">
			<img src="././assets/images/dualBallSpinner.svg" alt="" class="spinner-img" *ngIf="isLoading">
			<div *ngIf="DashboardContainer">

				<!-- <div *ngIf="headerbtn" class="tibo-mydash-dashboard-title" id="full-screen-mode-btn">{{ dashboardName }} -->
				<button class="tibo-mydash-chartcoloroptions-btn" type="button" pButton icon="pi pi-angle-left"
					(click)="back()" pTooltip="Back to Search" *ngIf="showBack"></button>
				<button class="tibo-mydash-chartcoloroptions-btn" type="button" pButton icon="fa fa-pencil-square-o"
					(click)="back()" pTooltip="Back to Edit" *ngIf="showEdit"></button>
				<!-- </div> -->
			</div>
			<div class="top-header-section-one">
				<span style="display:inline-flex" *ngIf="showDashboardList">
					<button id="mydash-dashlist-toggle-btn" class="tibo-mydash-dashlist-btn" type="button" pButton
						icon="pi pi-chevron-down" pTooltip="Dashboards" (click)="dashboardListFunc()"
						*ngIf="viewDashboardsList.length > 0" (click)="$event.stopPropagation()"></button>
					<div id="tibo-mydash-dashlist-container-id" class="tibo-mydash-dashlist-container"
						(click)="$event.stopPropagation()">
						<div class="dashlist-search">
							<span>Dashboard List</span><input type="text" class="form-input" [(ngModel)]="searchText"
								placeholder="Search" pInputText (input)="filterItems()"> <i class="fa fa-search"></i>
						</div>
						<!-- <p-panelMenu [model]="items | search: searchText" styleClass="tibo-mydash-dashlist-panel"
							[multiple]=false></p-panelMenu> -->
						<p-tree [value]="items" styleClass="tibo-mydash-dashlist-panel">
							<ng-template let-node pTemplate="default">
								<span class="node-content">
									<span class="star-icon" *ngIf="!node.label"
										style="margin-right:10px;cursor: pointer;">
										<i class="pi pi-star" (click)="callStarAPI(node)"
											[ngStyle]="{'color': (node.favourite?.toLowerCase() === 'y') ? '#ffca2b' : 'grey'}"></i>
									</span>
									<span class="label" *ngIf="node.label">{{ node.label }}</span>
									<span class="label" *ngIf="node.children" style="cursor: pointer;"
										(click)="changeDashboardFunc(node)">{{ node.children.label }}</span>
								</span>
							</ng-template>
						</p-tree>
					</div>

					<div *ngIf="viewDashboardsList.length > 0" class="tibo-mydash-openeddashlist-chip-container"
						(click)="$event.stopPropagation()" id="shepherd-dashboardList">
						<p-chip class="tibo-mydash-openeddashlist-chips" label="{{selectedDashboard?.name}}"></p-chip>
					</div>
					<p-overlayPanel #dashlistoverlaypanel styleClass="tibo-mydash-openeddashlist-overlaypanel"
						[showTransitionOptions]="'100ms'" appendTo="body" [showCloseIcon]=false>
						<ng-template pTemplate="body">
							<div>
								<p-chip *ngFor="let dashboard of viewDashboardsList" appendTo="body"
									styleClass="tibo-mydash-openeddashlist-overlaypanel-chips"
									(click)="visitedDashFunc(dashboard?.name,dashboard?.code); dashlistoverlaypanel.hide()">{{dashboard?.name}}
									<!-- <i class="pi pi-star"></i> -->
								</p-chip>
							</div>
						</ng-template>
					</p-overlayPanel>
					<div class="tibo-mydash-openeddashlist-chip-history" *ngIf="viewDashboardsList.length > 0"
						id="shepherd-dashboardRecentView">
						<button class="btn old-dashboard-btns" (click)="dashlistoverlaypanel.toggle($event)"
							type="button" pButton icon="fa fa-history" pTooltip="Recently Viewed"
							tooltipPosition="top"></button>
						<!-- <button class="btn favorite-icon-old-dashboard old-dashboard-btns" type="button" pButton
						icon="pi pi-star" pTooltip="Favorite" tooltipPosition="top"></button> -->
					</div>

					<label id="mydash-countdown-timer-label" class="tibo-mydash-refreshtime-label"></label>
				</span>
			</div>
			<div class="top-header-section-two">

				<button class="tibo-mydash-more-btn-icon tibo-mydash-chartcoloroptions-btn" type="button" pButton
					icon="pi pi-ellipsis-v" pTooltip="Options" tooltipPosition="top"
					(click)="moreoptions.toggle($event)" *ngIf="showDashboardList" id="shepherd-dashboardmore"></button>
				<p-tieredMenu #moreoptions [model]="moreItems" [popup]="true" appendTo="body"
					class="options-tieredMenu"></p-tieredMenu>
				<button class="tibo-mydash-chartcoloroptions-btn" type="button" pButton icon="pi pi-plus"
					pTooltip="Create-Dashboard" tooltipPosition="top" (click)="navigateToCreate()"
					*ngIf="showDashboardList" id="shepherd-dashboardCreate"></button>
				<button class="tibo-mydash-chartcoloroptions-btn" type="button" pButton icon="pi {{downloadSpinner}}"
					(click)="downloadOptions.toggle($event)" pTooltip="Download" tooltipPosition="top"
					*ngIf="showDashboardList" id="shepherd-dashboardDownload"></button>
				<p-tieredMenu #downloadOptions [model]="DownloadItems" [popup]="true" my="left top"
					at="left bottom"></p-tieredMenu>
				<button class="tibo-mydash-chartcoloroptions-btn" type="button" pButton icon="pi pi-window-maximize"
					pTooltip="{{FullScreen}}" tooltipPosition="top" *ngIf="showDashboardList" (click)="fullscreen()"
					id="shepherd-dashboardFullscreen"></button>
				<button class="tibo-mydash-chartcoloroptions-btn tibo-mydash-chartcoloroptions-btn-icon" type="button"
					pButton icon="pi pi-palette" pTooltip="Color Sets" tooltipPosition="top"
					(click)="chartscolorsetsoverlaypanel.toggle($event)" *ngIf="showDashboardList"
					id="shepherd-dashboardColorset"></button>
				<p-overlayPanel class="color-set-overlaypanel" #chartscolorsetsoverlaypanel
					[showTransitionOptions]="'100ms'" appendTo="body" [showCloseIcon]=false>
					<label class="p-grid p-ml-2 p-mb-2 theme-color" style="font-size: 16px;">Theme Colors</label>
					<p-tabView>
						<p-tabPanel header="Set Widget Color">
							<div class="color-main">
								<div class="theme-color">
								</div>
								<div class="color-set">
									<div class="single-row-color-set">
										<div class="p-p-2"
											[ngStyle]="{'background-color': colorSetOne[i], cursor:'pointer', heigth:'30px',width:'50px'}"
											*ngFor='let row of colorSetOne let i = index'
											(click)="changeChartColorsFunc('one')"><span pTooltip="{{row}}"
												class="inside-color">{{row}}</span></div>
									</div>
									<div class="single-row-color-set">
										<div class="p-p-2"
											[ngStyle]="{'background-color': colorSetTwo[i], cursor:'pointer'}"
											*ngFor='let row of colorSetTwo let i = index'
											(click)="changeChartColorsFunc('two')"><span pTooltip="{{row}}"
												class="inside-color">{{row}}</span></div>
									</div>
									<div class="single-row-color-set">
										<div class="p-p-2"
											[ngStyle]="{'background-color': colorSetThree[i], cursor:'pointer'}"
											*ngFor='let row of colorSetThree let i = index'
											(click)="changeChartColorsFunc('three')"><span pTooltip="{{row}}"
												class="inside-color">{{row}}</span></div>
									</div>
									<!-- <div class="single-row-color-set">
										<div class="p-p-2"
											[ngStyle]="{'background-color': colorSetFour[i], cursor:'pointer'}"
											*ngFor='let row of colorSetFour let i = index'
											(click)="changeChartColorsFunc('four')"><span pTooltip="{{row}}"
												class="inside-color">{{row}}</span></div>
									</div>
									<div class="single-row-color-set">
										<div class="p-p-2"
											[ngStyle]="{'background-color': colorSetFive[i], cursor:'pointer'}"
											*ngFor='let row of colorSetFive let i = index'
											(click)="changeChartColorsFunc('five')"><span pTooltip="{{row}}"
												class="inside-color">{{row}}</span></div>
									</div>
									<div class="single-row-color-set">
										<div class="p-p-2"
											[ngStyle]="{'background-color': colorSetSix[i], cursor:'pointer'}"
											*ngFor='let row of colorSetSix let i = index'
											(click)="changeChartColorsFunc('six')"><span pTooltip="{{row}}"
												class="inside-color">{{row}}</span></div>
									</div>
									<div class="single-row-color-set">
										<div class="p-p-2"
											[ngStyle]="{'background-color': colorSetSeven[i], cursor:'pointer'}"
											*ngFor='let row of colorSetSeven let i = index'
											(click)="changeChartColorsFunc('seven')"><span pTooltip="{{row}}"
												class="inside-color">{{row}}</span></div>
									</div>
									<div class="single-row-color-set">
										<div class="p-p-2"
											[ngStyle]="{'background-color': colorSetEight[i], cursor:'pointer'}"
											*ngFor='let row of colorSetEight let i = index'
											(click)="changeChartColorsFunc('seven')"><span pTooltip="{{row}}"
												class="inside-color">{{row}}</span></div>
									</div> -->
								</div>
							</div>
						</p-tabPanel>
						<p-tabPanel header="Set Background Color">
							<!-- <div class="color-setone">
								<button class="rowOne hover-fx" *ngFor="let color of colorOne ; let i = index"
									[ngStyle]="{'background-color': color}" (click)="getcolor(color, i)"><span
										class="focus" *ngIf="i === buttonIndex"
										[ngValue]="color">&#10003;</span></button>
								<button class="rowOne hover-fx"
									[ngStyle]="{'background-image': 'linear-gradient(red,lightgreen,lightblue)'}"
									(click)="getcolor(colorOne, 12)"><span class="focus"
										*ngIf="allColorButton">&#10003;</span></button>
							</div> -->
							<div class="color-setone">
								<button class="rowOne hover-fx" *ngFor="let color of colorOne; let i = index"
									[ngStyle]="{'background-color': color}" (click)="getcolor(color, i)">
									<span class="focus" *ngIf="selectedColor === color">&#10003;</span>
								</button>
								<button class="rowOne hover-fx"
									[ngStyle]="{'background-image': 'linear-gradient(red,lightgreen,lightblue)'}"
									(click)="selectedColor = colorOne[12]" (click)="getcolor(this.colorOne,12)">
									<span class="focus" *ngIf="allColorButton">&#10003;</span>
								</button>
							</div>
						</p-tabPanel>
					</p-tabView>
				</p-overlayPanel>
			</div>
		</div>
		<p-dialog [(visible)]="shareDashDialBoxDisplayBool" styleClass="tibo-mydash-sharedash-box" [modal]="true"
			[draggable]="false" [resizable]="false" (onHide)="dialogBoxOnCloseFunc($event)">
			<ng-template pTemplate="header">
				<label class="tibo-mydash-sharedash-box-sharelabel">Share {{selectedDashboard.name}}</label>
			</ng-template>
			<p-tabView [(activeIndex)]="shareDashTabIndex" (onChange)="shareDashTabChanFunc($event)"
				styleClass="share-tabview">
				<p-tabPanel header="Provide Access To" class="tibo-mydash-sharedash-box-tabpanel">
					<div class="p-grid p-col-12 p-ai-center vertical-container">
						<label class="p-col-12">Enter User Name(s) <span
								class="tibo-mydash-paramdash-param-title-mand">*</span></label>
						<p-autoComplete [autofocus]="true" [(ngModel)]="shareDashUserNamesArr"
							[suggestions]="shareDashSrchUserNamesArr" (completeMethod)="search($event)"
							[multiple]="true" scrollHeight="155px"></p-autoComplete>
					</div>
				</p-tabPanel>
				<!-- <p-tabPanel header="One time share by Email" class="tibo-mydash-sharedash-box-tabpanel">
					<div class="p-grid p-col-12 p-ai-center vertical-container">
						<label class="p-col-12">Enter Email Id(s) <span class="tibo-mydash-paramdash-param-title-mand">*
							</span>
							<span class="p-ml-2 tibo-mydash-sharedash-box-tabpanel-span">(To add multiple Email ids,
								enter an email id and press Enter)</span></label>
						<p-chips class="p-p-1" [(ngModel)]="shareDashEmailIdsArr" [allowDuplicate]="false"></p-chips>
					</div>
				</p-tabPanel> -->
			</p-tabView>
			<ng-template pTemplate="footer">
				<p-button icon="pi pi-share-alt" label="Share" (click)="shareDashFunc($event)"></p-button>
			</ng-template>
		</p-dialog>
	</div>
	<div class="tibo-mydash-charts-container" (click)="chartsDivContainerClick($event)">
		<!-- <p-progressSpinner styleClass="tibo-mydash-dash-spinner custom-spinner"
			animationDuration="1s"></p-progressSpinner> -->
		<!-- <img src="././assets/images/dualBallSpinner.svg" alt="" class="spinner-img" *ngIf="isLoading"> -->
		<!-- <div class="chart-container" #chartContainerDiv id="chartContent"
			[ngClass]="{'chart-container-2':downloadSpinner === 'pi-spin pi-spinner'}"> -->

		<div class="title">
			<p class="title-one" id="title-dashboard" *ngIf="showDashboardList">{{ dashboardName }}</p>
			<div *ngIf="loaderShow"> <p-progressBar mode="indeterminate" [style]="{'height': '3px'}"></p-progressBar>
			</div>
			<div *ngIf="showParameters" style="display:flex">
				<div class="tibo-mydash-dashboard-title">
					<!-- <p class="title-one" id="title-dashboard">{{ dashboardName }}</p> -->
					<!-- <div *ngIf="showParameters"> -->
					<div class="tibo-mydash-dashlistbtn-dashoptsbtn-container-2">
						<div *ngFor="let row of parameterElementsArray let i = index" class="row"
							style="float:left; padding: 0px 10px 0px;">
							<div *ngIf="parameterElementsArray[i].fetchedRecordsBool">
								<div style="text-align:left ">
								</div>
								<input type="text" *ngIf="parameterElementsArray[i].displayType == 'Text Field'" style="border-radius: 20px;
							border: 0.5px solid #d0d6de;color: #121212;height: 33px;top: 10px;position: relative;left:10px"
									[attr.selectInfoIndex]=i
									placeholder="{{'Enter ' + parameterElementsArray[i]?.parameterName.replaceAll('_', ' ') }}"
									pTooltip="{{'Enter ' + parameterElementsArray[i].parameterName.replaceAll('_', ' ') }}"
									tooltipPosition="top" (keyup)="onChange($event,refEl,i)"
									[(ngModel)]="parameterElementsArray[i].selectedData">

								<span *ngIf="parameterElementsArray[i].displayType == 'Radio'"
									style="border-radius: 20px;border: 0.5px solid #d0d6de;
							color: #121212;height: 34px;background-color: white;    font-size: 13px; padding: 9px;top: 15px;position: relative;">
									<!-- <span
										*ngFor="let radioItem of parameterElementsArray[i].fetchedRecords.records.records">
										<input type="radio" name="radiobutton"
											[value]="radioItem[parameterElementsArray[i].fetchedRecords.records?.parameterValue] || radioItem"
											[attr.selectInfoIndex]=i (change)="onChange($event,radioItem,i)"
											[(ngModel)]="parameterElementsArray[i].selectedData">
										<label>
											{{
											radioItem[parameterElementsArray[i].fetchedRecords.records?.parameterLabel]
											||
											radioItem }}
										</label>

									</span> -->
									<span
										*ngFor="let radioItem of (parameterElementsArray[i].fetchedRecords?.records?.records ? parameterElementsArray[i].fetchedRecords.records.records : parameterElementsArray[i].defaultValue.split(','))"
										class="radio">
										<p-radioButton name="radiobutton"
											[value]="radioItem[parameterElementsArray[i].fetchedRecords.records?.parameterValue] || radioItem"
											[attr.selectInfoIndex]=i (onClick)="onChange($event,refEl,i)"
											[(ngModel)]="parameterElementsArray[i].selectedData" #refEl></p-radioButton>
										<label>{{
											radioItem[parameterElementsArray[i].fetchedRecords.records?.parameterLabel]
											||
											radioItem }}</label>
									</span>
								</span>
								<p-dropdown styleClass="tibo-mydash-paramdash-param-dropdown" [filter]="true"
									appendTo="body" *ngIf="parameterElementsArray[i].displayType == 'Select'"
									[attr.selectInfoIndex]=i
									[options]="parameterElementsArray[i].fetchedRecords?.records?.records"
									[optionLabel]="parameterElementsArray[i].fetchedRecords?.records?.parameterLabel "
									[optionValue]="parameterElementsArray[i].fetchedRecords?.records?.parameterValue"
									placeholder="{{'Select ' + parameterElementsArray[i].parameterName.replaceAll('_', ' ') }}"
									pTooltip="{{'Select ' + parameterElementsArray[i].parameterName.replaceAll('_', ' ') }}"
									tooltipPosition="top" [(ngModel)]="parameterElementsArray[i].selectedData"
									(ngModelChange)="onChange($event,refEl,i)" #refEl>
								</p-dropdown>
								<p-multiSelect class="search-multiselect" appendTo="body"
									*ngIf="parameterElementsArray[i].displayType == 'Multi Select'"
									[attr.selectInfoIndex]=i
									[options]="parameterElementsArray[i].fetchedRecords?.listEle"
									[optionLabel]="parameterElementsArray[i].fetchedRecords?.records?.parameterLabel"
									[optionValue]="parameterElementsArray[i].fetchedRecords?.records?.parameterValue"
									[defaultLabel]="'Please select '"
									[(ngModel)]="parameterElementsArray[i].selectedData"
									placeholder="{{'Select ' + parameterElementsArray[i].parameterName.replaceAll('_', ' ') }}"
									pTooltip="{{'Select ' + parameterElementsArray[i].parameterName.replaceAll('_', ' ') }}"
									tooltipPosition="top" (onChange)="onChange($event,refEl,i)" #refEl>
								</p-multiSelect>
								<p-calendar styleClass="tibo-mydash-paramdash-param-calendar"
									*ngIf="parameterElementsArray[i].displayType == 'Date'" dateFormat="mm/dd/yy"
									appendTo="body" [monthNavigator]="true" [yearNavigator]="true" yearRange="1000:3000"
									[attr.selectInfoIndex]=i
									placeholder="{{'Select ' + parameterElementsArray[i].parameterName.replaceAll('_', ' ') }}"
									pTooltip="{{'Select ' + parameterElementsArray[i].parameterName.replaceAll('_', ' ') }}"
									tooltipPosition="top" (onSelect)="onChange($event,refEl,i)"
									(ngModelChange)="onManualInputChange($event, refEl, i)" showIcon="true"
									[(ngModel)]="parameterElementsArray[i].selectedData" #refEl>
								</p-calendar>

							</div>
						</div>
					</div>

					<!-- </div> -->
				</div>
				<div class="subBtn">
					<button pButton type="button" id="submitbutton-id" label="Submit" style="border-radius: 20px;"
						(click)="onFilterSubmitClick()"></button>
				</div>
			</div>
			
			<div *ngIf="loaderShow1"> <p-progressBar mode="indeterminate" [style]="{'height': '3px'}"></p-progressBar>
			</div>
		</div>
		<img src="././assets/images/dualBallSpinner.svg" alt="" class="spinner-img" *ngIf="isLoading11">
		<div class="chart-container" #chartContainerDiv id="chartContent"
			[ngClass]="{'chart-container-2':downloadSpinner === 'pi-spin pi-spinner'}">
			<div id="dashboard-scroll-wrapper" class="tibo-mydash-nonparamdash-wrapper">
				<p-scrollPanel styleClass="tibo-mydash-nonparamdash-scrollpanel custombar2 ">
					<div id="widgets-id" class="tibo-mydash-nonparamdash-widget"
						*ngFor="let row of randomIdArray let i = index">
						<div class="widget-class" [ngClass]="{'widget-class-1': totalColumns.length == 1,'widget-class-2': totalColumns.length == 2,
										'widget-class-3': totalColumns.length == 3}" [attr.objectCordinates]="(i+1)+','+(j+1)"
							[attr.id]=randomIdArray[i][j] [attr.empty]="true"
							*ngFor="let column of randomIdArray[i]; let j = index;"
							[ngStyle]="{'background-color': wigetBackgroundColor}">
							<img src="././assets/images/dualBallSpinner.svg" id="{{ 'loader'+(i+1)+(j+1) }}" alt=""
								class="spinner-img">
							<!-- <p-progressSpinner id="{{ 'loader'+(i+1)+(j+1) }}" styleClass="custom-spinner" strokeWidth="4"
								fill="#FFFFFF" animationDuration="1.5s">
							</p-progressSpinner> -->
						</div>
					</div>
				</p-scrollPanel>
			</div> <!-- dashboard scroll wrapper -->
			<div id="dashboard-parameterized-scroll-wrapper" class="tibo-mydash-paramdash-wrapper">
				<div id="dashboard-parameterized-scroll-view" class="tibo-mydash-paramdash-scroll-wrapper">
					<p-scrollPanel styleClass="tibo-mydash-paramdash-scrollpanel custombar2">
						<div class="tibo-mydash-paramdash-widget"
							*ngFor="let row of parameterizedDashboardRandomArray let i = index">
							<div class="widget-class" [ngClass]="{'widget-class-1': totalColumns.length == 1,'widget-class-2': totalColumns.length == 2,
											'widget-class-3': totalColumns.length == 3}" [attr.objectCordinates]="(i+1)+','+(j+1)"
								[attr.id]=parameterizedDashboardRandomArray[i][j] [attr.empty]="true"
								*ngFor="let column of parameterizedDashboardRandomArray[i]; let j = index;"
								[ngStyle]="{'background-color': wigetBackgroundColor}">
								<img src="././assets/images/dualBallSpinner.svg" id="{{ 'loader'+(i+1)+(j+1) }}" alt=""
									class="spinner-img">
								<!-- <p-progressSpinner styleClass="tibo-mydash-widget-spinner custom-spinner"
									strokeWidth="4" fill="#FFFFFF" animationDuration="1.5s">
								</p-progressSpinner> -->
							</div>
						</div>
					</p-scrollPanel>
				</div>
			</div>

		</div>

		<!-- parameterized wrapper -->
	</div>

	<!-- charts container -->
	<!-- <div class="tibo-mydash-wrapper">
	<div class="container" *ngIf="showGrid">
		<div class="drpFilterChkbox" style="float:right">
				<button type="button" class="drpButton" (click)="showdropdown=!showdropdown"><i class="pi pi-eye" pTooltip="Show/Hide Column" tooltipPosition="top"></i></button>
				<button class="drpButton" (click)="Refresh(coldata )"><i class="pi pi-refresh" pTooltip="Refresh" tooltipPosition="top"></i></button>
				<button class="drpButton" (click)="showmenu=!showmenu"><i class="pi pi-download" pTooltip="Download" tooltipPosition="top"></i></button>
				<span class="p-input-icon-right">
					<i class="pi pi-search"></i>
					<input type="text" pInputText [(ngModel)]="value"  placeholder="Search"/>
				</span>
				<div *ngIf="this.showdropdown" class="DropMenus" >
					<input class="form-control" type="text" name="search" [(ngModel)]="searchText" autocomplete="off" placeholder="Search...">
					<div class="dropContainer" *ngFor="let d of coldata  |filter: searchText ">
					<input type="checkbox"  name="{{d.field}}" (change)="binSelect($event,d)" [checked]="d.checked" >{{d.headerName}}<br></div></div>
					<div *ngIf="showmenu" class="downloadmenu">
						<button type="button" class="downloadall" (click)="download1()" >Download All</button><br>
						<button type="button" class="downloadall" (click)="download2()">Download filtered grid</button>
			</div>
		</div>
		<div class="aggriid">
		<ag-grid-angular 
						style="width: 100%; height:500px;clear: both;" 
						class="ag-theme-alpine"
						[rowData]="this.rowData |filter: value" 
						[columnDefs]="this.columnDefs "
						[defaultColDef]="defaultColDef"
						[enableFilter]="true"
						[pagination]="true"
						[gridOptions]="gridOptions"
						[setQuickFilter]="quickFilterText" 
						>
		</ag-grid-angular>
		</div>
		</div>
		</div> -->
</div>
<p-toast></p-toast>